import { render, staticRenderFns } from "./TaskTemplateForm.vue?vue&type=template&id=d24a84f6&scoped=true&"
import script from "./TaskTemplateForm.vue?vue&type=script&lang=js&"
export * from "./TaskTemplateForm.vue?vue&type=script&lang=js&"
import style0 from "./TaskTemplateForm.vue?vue&type=style&index=0&id=d24a84f6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d24a84f6",
  null
  
)

export default component.exports